import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'

import ChatRoom from '../components/chat/ChatRoom'
import ChatService from '../services/ChatService'

// Full-page wrapper for a single chat thread.
// Receives the thread via location.state when navigating from MessagesPage,
// or falls back to fetching the thread list and finding it by ID.
const MessageThreadPage = ({ currentUser }) => {
  const { threadId } = useParams()
  const location = useLocation()
  const history = useHistory()

  const [thread, setThread] = useState(location.state?.thread || null)
  const [loading, setLoading] = useState(!thread)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    if (!thread) {
      const load = async () => {
        try {
          const data = await ChatService.getThreads(1, 200)
          const found = (data.results || []).find(t => t.id === threadId)
          if (found) {
            setThread(found)
          } else {
            setNotFound(true)
          }
        } catch {
          setNotFound(true)
        } finally {
          setLoading(false)
        }
      }
      load()
    }
  }, [thread, threadId])

  return (
    <div className="mt-4">
      {loading && <div className="text-center text-muted">Loading conversation…</div>}
      {notFound && (
        <div className="text-center">
          <p className="text-muted">Conversation not found.</p>
          <button className="btn btn-outline-primary btn-sm" onClick={() => history.replace('/messages')}>
            Back to Messages
          </button>
        </div>
      )}
      {/* Fixed height: full viewport minus topnav (4.5rem) + bottomnav (4.5rem) + container padding */}
      {!loading && !notFound && thread && (
        <div style={{ height: 'calc(100vh - 11rem)', display: 'flex', flexDirection: 'column' }}>
          {thread.caseNumber && (
            <div className="px-3 py-2 bg-light border-bottom">
              {thread.clientName && <div className="font-weight-bold small">{thread.clientName}</div>}
              <div className="small">
                Case #: <Link to={`/cases/${thread.caseNumber}`}>{thread.caseNumber}</Link>
              </div>
            </div>
          )}
          <ChatRoom thread={thread} currentUser={currentUser} onBack={() => history.push('/messages')} />
        </div>
      )}
    </div>
  )
}

export default MessageThreadPage
